import React from 'react';

/**
 * ScoreRing — circular security-score dial (0–100). Colour follows
 * risk banding unless a tone is forced. The centre shows the score.
 */
export function ScoreRing({ value = 0, max = 100, size = 120, stroke = 10, tone, label, style = {}, ...rest }) {
  const pct = Math.max(0, Math.min(1, value / max));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const band = value >= 80 ? 'var(--secure-600)' : value >= 55 ? 'var(--warn-600)' : 'var(--crit-600)';
  const map = { secure: 'var(--secure-600)', warning: 'var(--warn-600)', critical: 'var(--crit-600)', brand: 'var(--brand-600)' };
  const color = tone ? (map[tone] || band) : band;
  return (
    <div style={{ position: 'relative', width: size, height: size, ...style }} {...rest}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--ink-100)" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - pct)}
          style={{ transition: 'stroke-dashoffset var(--dur-slow) var(--ease-out)' }}
        />
      </svg>
      <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        <span style={{ fontFamily: 'var(--font-mono)', fontSize: size * 0.28, fontWeight: 'var(--fw-semibold)', color: 'var(--text-strong)', lineHeight: 1 }}>{Math.round(value)}</span>
        {label && <span style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', color: 'var(--text-muted)', letterSpacing: 'var(--ls-caps)', textTransform: 'uppercase' }}>{label}</span>}
      </div>
    </div>
  );
}
